export default {
    /**
     * @override
     */
    data() {
        return {
            minDateTime: this.$moment().format('YYYY-MM-DD hh:mm:ss'),
            dayStr: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
            timeStr: ['HH', 'MM', 'SS'],
            popperProps: {
                arrowOffsetScaling: 0,
                popperOptions: {
                    modifiers: {
                        preventOverflow: {
                            padding: 20
                        }
                    }
                }
            }
        };
    },

    /**
     * @override
     */
    mounted() {
        // FIX to set autocomplete to datepickers
        const inputs = document.getElementsByClassName('vue-input');
        for (let index = 0; index < inputs.length; index++) {
            const element = inputs[index];
            element.setAttribute('autocomplete', 'off');
        }
    }
};
